const { makeStyles } = require('@material-ui/core');

export const useDefaultErrorStyles = makeStyles(theme => ({
  root: {
    width              : '100%',
    height             : '100%',
    display            : 'grid',
    gridTemplateColumns: '1fr',
    gridGap            : theme.spacing(4),
    padding            : theme.spacing(3),
    margin             : theme.spacing(3, 0),
    justifyItems       : 'center',
  },
  icon: {
    fontSize: '80px',
    color   : theme.palette.error.main,
  },
}));
